<template>
  <div>
    <div class="panel-heading" style="display: flex; align-items: center; justify-content: space-between;">
      <h4 class="panel-title" style="margin: 0;">{{ $t('orderStatusSettings.title') }}</h4>
      <v-btn v-if="canEdit" color="primary" :loading="saving" @click="saveAll" style="height:auto">{{ $t('common.save') }}</v-btn>
    </div>

    <div class="panel-body" style="display: block;">
      <p style="color:#666; font-size: 13px; margin: 0 0 12px;">
        {{ $t('orderStatusSettings.description') }}
      </p>

      <div class="row">
        <div class="col-xs-12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>{{ $t('columns.id') }}</th>
                <th>{{ $t('columns.type') }}</th>
                <th>{{ $t('orderStatusSettings.displayNameEnColumn') }}</th>
                <th>{{ $t('orderStatusSettings.displayNameArColumn') }}</th>
                <th>{{ $t('orderStatusSettings.displayNameKuColumn') }}</th>
                <th>{{ $t('orderStatusSettings.displayNameTrColumn') }}</th>
                <th>{{ $t('customer.color') }}</th>
                <th>{{ $t('orderStatusSettings.visibleColumn') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in editableRows" :key="row.status_id">
                <td>{{ row.status_id }}</td>
                <td><code>{{ row.type }}</code></td>
                <td>
                  <v-text-field
                    v-model="row.display_name_en"
                    dense
                    hide-details
                    :disabled="!canEdit"
                    :placeholder="$t('orderStatusSettings.egNewOrderPlaceholder')"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field v-model="row.display_name_ar" dense hide-details :disabled="!canEdit"></v-text-field>
                </td>
                <td>
                  <v-text-field v-model="row.display_name_ku" dense hide-details :disabled="!canEdit"></v-text-field>
                </td>
                <td>
                  <v-text-field v-model="row.display_name_tr" dense hide-details :disabled="!canEdit"></v-text-field>
                </td>
                <td>
                  <div style="display:flex; align-items:center; gap:8px;">
                    <input type="color" v-model="row.color" :disabled="!canEdit" style="width:32px; height:28px; padding:0; border:1px solid #ccc;" />
                    <span style="font-size:12px; color:#666;">{{ row.color }}</span>
                  </div>
                </td>
                <td>
                  <v-switch v-model="row.is_visible" :disabled="!canEdit" hide-details></v-switch>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import statusHelpers from '../../mixins/statusHelpers'

export default {
  mixins: [statusHelpers],

  mounted() {
    this.getResults()
  },

  data() {
    return {
      editableRows: [],
      saving: false
    }
  },

  computed: {
    canEdit() {
      return this.$_has_perm('edit_order_status_settings')
    }
  },

  methods: {
    getResults() {
      this.$_fetch_statuses().then(statuses => {
        this.editableRows = statuses.map(row => ({ ...row }))
      })
    },

    saveAll() {
      this.saving = true
      const token = localStorage.getItem('access_token')

      const requests = this.editableRows.map(row => {
        const payload = {
          display_name_en: row.display_name_en,
          display_name_ar: row.display_name_ar,
          display_name_ku: row.display_name_ku,
          display_name_tr: row.display_name_tr,
          color: row.color,
          is_visible: row.is_visible
        }

        return axios.put(`api/status/${row.status_id}`, payload, { headers: { Authorization: 'Bearer ' + token } })
      })

      Promise.all(requests)
        .then(() => {
          this.saving = false
          swal({ title: this.$t('admin.savedTitle'), icon: 'success', timer: 1200, buttons: false })
        })
        .catch(error => {
          this.saving = false
          const message = (error.response && error.response.data && error.response.data.message) || this.$t('orderStatusSettings.failedToSaveOneOrMoreStatuses')
          swal(this.$t('common.error'), message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.table.table-bordered th,
.table.table-bordered td {
  padding: 4px 8px !important;
  font-size: 13px !important;
  vertical-align: middle !important;
}

.table.table-bordered {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/orderStatus/orderStatusSettings.vue